import React, { useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';

import { connects } from '../../pages/main/data';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './connect_slide.module.css';
import './connect_slide.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ConnectSlide = () => {
  const [swiper, setSwiper] = useState(null);
  const [connect, setConnect] = useState(connects[0]);

  const pagination = { clickable: false };

  useEffect(() => {
    if (!swiper || !connect) return;

    let index = connects.findIndex((item) => item.title === connect.title);
    !swiper.destroyed && swiper.slideTo(index + 1);
  }, [swiper, connect]);

  return (
    <>
      <div className={styles.connectImg}>
        <img
          src={process.env.PUBLIC_URL + '/imgs/main/connect/main.png'}
          alt='unos_connect'
        />

        <div className={styles.conIcons}>
          {connects.map((item, index) => {
            return (
              <span
                key={index}
                onClick={() => setConnect(item)}
                className={
                  item.title === connect.title
                    ? [styles.conIcon, styles.activeIcon].join(' ')
                    : styles.conIcon
                }
              >
                +
              </span>
            );
          })}
        </div>
      </div>

      <div className={styles.connectInfoBox}>
        <Swiper
          onSwiper={(swiper) => setSwiper(swiper)}
          modules={[Pagination]}
          pagination={pagination}
          className={[styles.swiper, 'connect_swiper'].join(' ')}
          slidesPerView={1.2}
          spaceBetween={20}
          centeredSlides={true}
          loop
          breakpoints={{
            769: {
              slidesPerView: 1,
              spaceBetween: 0,
              allowTouchMove: false,
            },
          }}
        >
          {connects.map((connect, index) => (
            <SwiperSlide className={styles.slide} key={index}>
              <div className={styles.imgBox}>
                <LazyLoadImage
                  src={
                    process.env.PUBLIC_URL +
                    `/imgs/main/connect/${connect.img}.png`
                  }
                  placeholderSrc={
                    process.env.PUBLIC_URL +
                    `/imgs/main/connect/${connect.img}_blur.png`
                  }
                  alt=''
                />
              </div>

              <div className={styles.infoText}>
                <h4>{connect.title}</h4>
                <p>{connect.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default ConnectSlide;
